module.exports = __webpack_public_path__ + "img/pay-sdk-transaction-start.fcad013d.png";